module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightItalic.542b437a.ttf";